enum EngineType {
  MainEngine = "Main Engine",
  AuxEngine = "Aux Engine",
  Boiler = "Boiler",
}

export default EngineType;